import * as S from './styles'
import { useTranslation } from 'react-i18next'

const CustomHistopathology = () => {
  const { t } = useTranslation()

  return (
    <S.CustomHistopathologyContainer>
      {Array.from({ length: 14 }).map((_, idx) => (
        <li>{t(`titles.histopathology.${idx + 1}`)}</li>
      ))}
    </S.CustomHistopathologyContainer>
  )
}

export default CustomHistopathology
